import { BreadcrumbsKey } from 'components/page/i18n/TModules';

export const translations = {
  [BreadcrumbsKey]: {
    Home: 'Accueil',
    Campaigns: 'Campagnes',
    Customers: 'Clients',
    List: 'Liste',
    LanguageSelector: 'Sélecteur de langue',
    Preference: 'Préférences',
    Rewards: 'Récompenses',
    LevelUpMarketing: 'Amélioration du marketing',
    Info: 'Info',
    Audience: 'Audience',
    Mechanics: 'Mécanique',
    Review: 'Revue'
  }
};
